export function fmtNumber(n) {
  if (n === null || n === undefined) return "0";
  return Number(n).toLocaleString("pt-BR");
}

export function fmtPctAbs(n) {
  if (n === null || n === undefined || Number.isNaN(n)) return "0%";
  return `${Math.abs(Number(n)).toFixed(2).replace(".", ",")}%`;
}

export function fmtRatio(n) {
  if (!n) return "0%";
  return `${Number(n).toFixed(2).replace(".", ",")}%`;
}

// O servidor manda a faixa em UTC sem o "Z" ("2026-10-26T03:00:00") e com o fim
// EXCLUSIVO (meia-noite do dia seguinte). Lido como hora local, "Hoje" aparecia
// como "25/10/2026 → 26/10/2026" e o Personalizado ganhava um dia a mais
// (26/10 no lugar de 25/10). `fimExclusivo` mostra o último dia que entra.
const comFuso = (iso) => (/(?:[zZ]|[+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`);

export function fmtDateBR(iso, { fimExclusivo = false } = {}) {
  if (!iso) return "";
  try {
    const d = new Date(comFuso(String(iso)));
    if (Number.isNaN(d.getTime())) return "";
    if (fimExclusivo) d.setTime(d.getTime() - 1);
    return d.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo", day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return "";
  }
}
